var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ProjectItem',[_c('ProjectTitle',{attrs:{"title":"健康指南"}}),_vm._l((_vm.guides),function(item,index){return _c('div',{key:index,staticClass:"zn-item"},[_c('ItemDetail',{attrs:{"item":item}}),(index != _vm.total - 1)?_c('div',{staticClass:"item-divider"}):_vm._e()],1)})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }